import { render } from "./TrainingManagement.vue?vue&type=template&id=b9420682&scoped=true"
import script from "./TrainingManagement.vue?vue&type=script&lang=js"
export * from "./TrainingManagement.vue?vue&type=script&lang=js"

import "./TrainingManagement.vue?vue&type=style&index=0&id=b9420682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9420682"]])

export default __exports__